import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AgentLanding.css';

const AgentLanding = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/agent');
  };

  const handleSignUp = () => {
    navigate('/agent?action=register');
  };

  return (
    <div className="agent-landing">
      {/* Animated Background */}
      <div className="landing-background">
        <div className="bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>

      <div className="landing-wrapper">
        <div className="landing-card">
          {/* Logo and Header */}
          <div className="landing-header">
            <div className="logo-container-landing">
              <div className="logo-icon-landing">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h1 className="landing-title">Agent Portal</h1>
            <p className="landing-subtitle">Welcome to The Monarch Insurance Company</p>
            <p className="landing-description">Manage your business, view transactions, and access your dashboard</p>
          </div>

          {/* Action Buttons */}
          <div className="landing-actions">
            <button
              className="action-button sign-in-button"
              onClick={handleSignIn}
            >
              <div className="button-content">
                <svg className="button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                  <polyline points="10 17 15 12 10 7"/>
                  <line x1="15" y1="12" x2="3" y2="12"/>
                </svg>
                <div className="button-text">
                  <span className="button-title">Sign In</span>
                  <span className="button-subtitle">Access your existing account</span>
                </div>
              </div>
              <svg className="arrow-right" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>

            {/* Sign-up */}
            <button
              className="action-button sign-up-button"
              onClick={handleSignUp}
            >
              <div className="button-content">
                <svg className="button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="8.5" cy="7" r="4"/>
                  <line x1="20" y1="8" x2="20" y2="14"/>
                  <line x1="23" y1="11" x2="17" y2="11"/>
                </svg>
                <div className="button-text">
                  <span className="button-title">Sign Up</span>
                  <span className="button-subtitle">Create a new agent account</span>
                </div>
              </div>
              <svg className="arrow-right" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </div>

          {/* Features */}
          <div className="landing-features">
            <div className="feature-item">
              <div className="feature-icon">📊</div>
              <span className="feature-text">Business Dashboard</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">💼</div>
              <span className="feature-text">Transaction Management</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🔒</div>
              <span className="feature-text">Secure Access</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentLanding;
